import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import type { LauncherPlacement } from '../components/placement/launcherPlacement';

import { selectJotSupportPlacement } from './placementSelectors';
import { setPlacement } from './placementSlice';

export function useJotSupportPlacement() {
  const dispatch = useDispatch();
  const placement = useSelector(selectJotSupportPlacement);
  const savePlacement = useCallback(
    (next: LauncherPlacement) => {
      dispatch(setPlacement(next));
    },
    [dispatch],
  );
  return { placement, savePlacement };
}
